<template>
  <div class="root d-inline-block">
    <toggle-button @change="change($event)" :value="!isActive" color="#82C7EB" :width="105" :height="25" :sync="true"
                   :labels="{unchecked: 'کالاهای موجود', checked: 'کالاهای موجود'}"/>
  </div>
</template>

<script>
  import EventBus from "../_framework/bus.js";
  import ToggleButton from "vue-js-toggle-button/src/Button";

  export default {
    name: "stock-filter-button",
    props: ["header", "params", "th"],
    components: {
      ToggleButton
    },
    data() {
      return {
        isActive: true,
        text: "کالاهای موجود"
      };
    },
    methods: {
      change(e) {

        if (e.value === true) {
          this.$emit("onFetchList", {havestock: true });
        } else {
          this.$emit("onFetchList", {havestock: false });
        }
        this.isActive = !this.isActive;
        this.text = this.isActive ? "کالاهای موجود" : "تمام کالاها";
      },
      btnClicked() {
        this.isActive = !this.isActive;
        this.text = this.isActive ? "کالاهای موجود" : "تمام کالاها";
        this.params.onClick();
      }
    }
  };
</script>

<style scoped>
  .vue-js-switch {
    font-size: 12px;
  }
</style>
